// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack, Text } from '@mantine/core';

import { BendDimensionInputs } from '../Fields/BendDimensionInputs';
import { BendMaterialInputs } from '../Fields/BendMaterialInputs';
import { BendReviewFields } from '../Fields/BendReviewFields';
import { BendTypeSelect } from '../Fields/BendTypeSelect';
import type { BendCreatorStep } from './BendCreatorStepPanel';

export type FieldsComponentProps = {
  onChangeStep: (step: BendCreatorStep | null) => void;
};

type FieldsComponentData = {
  description: string;
  Component: React.FC<FieldsComponentProps>;
};

const fieldsComponentLookup = {
  'Material': { description: 'Pick what is on the rack.', Component: (_) => <BendMaterialInputs /> },
  'Bend Type': {
    description: 'The shape of the part. The model updates as you pick.',
    Component: (_) => <BendTypeSelect />,
  },
  'Dimensions': {
    description: 'Runs are measured center-to-center. The model highlights what you are editing.',
    Component: (props) => <BendDimensionInputs {...props} />,
  },
  'Review': {
    description: 'Name it, set the quantity, then add it to the bend list.',
    Component: (_) => <BendReviewFields />,
  },
} as const satisfies Record<BendCreatorStep, FieldsComponentData>;

type Props = {
  stepName: BendCreatorStep;
  onChangeStep: (step: BendCreatorStep | null) => void;
};

export const BendCreatorStepFields = ({ stepName, onChangeStep }: Props) => {
  const { description, Component } = fieldsComponentLookup[stepName];
  return (
    <Stack>
      <Text c="dimmed" fz="sm">
        {description}
      </Text>
      <Component onChangeStep={onChangeStep} />
    </Stack>
  );
};
